

document.addEventListener('DOMContentLoaded', function () {

	// document.addEventListener('cart:open', this.open.bind(this));
	// fire cart:open event
	// document.dispatchEvent(new CustomEvent('cart:open'));

	window.removeGift = function (event, itemKey) {
		event.preventDefault();
		const data = {
			updates: {
				[itemKey]: 0,
			},
		};
		fetch(theme.routes.cartUpdateUrl, {
			body: JSON.stringify(data),
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		}).then((response) => {
			if (response.ok) {
				document.dispatchEvent(new CustomEvent('cart:build', { detail: { skipAddingGifts: true } }));
			}
		});
	};
});

document.addEventListener('atc:variant', function (event) {
	const { btn, variantId } = event.detail;
	const addedProduct = {
		id: variantId,
		quantity: 1,
	};
	const data = {
		updates: {
			[variantId]: 1,
		},
	};
	btn.setAttribute('disabled', 'disabled');
	fetch(theme.routes.cartUpdateUrl, {
		body: JSON.stringify(data),
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
	})
		.then((response) => {
			btn.removeAttribute('disabled');
			document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { addedProduct}}));
			if (response.ok) {
				document.dispatchEvent(new CustomEvent('cart:build'));
			}
		})
		.catch((error) => {
			btn.removeAttribute('disabled');
			console.error('Error:', error);
		});
});

class UnderlineElement extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.underlineSymbol = window.underlineLogic.underlineLogicSymbol;
		this.underlineSymbolWithOffset = window.underlineLogic.underlineLogicSymbolOffset;
		this._render(this.underlineSymbol, this.underlineSymbolWithOffset);
	}
	_render(symbol, offsetSymbol) {
		const escapedSymbol = symbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		const escapedSymbolWithOffset = offsetSymbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		const span = document.createElement('span');
		span.innerHTML = this.innerHTML;
		if (escapedSymbolWithOffset) {
			span.innerHTML = this.innerHTML.replace(
				new RegExp(`${escapedSymbolWithOffset}(.*?)${escapedSymbolWithOffset}`, 'g'),
				'<u class="offset">$1</u>',
			);
			const underlineElement = span.querySelector('.offset');
			if (underlineElement) {
				const computedStyle = window.getComputedStyle(this);
				const fontSize = parseFloat(computedStyle.fontSize);
				underlineElement.style.setProperty('--text-underline-offset', `${Math.round(fontSize / 4) - 1}px`);
			}
		}
		span.innerHTML = span.innerHTML.replace(new RegExp(`${escapedSymbol}(.*?)${escapedSymbol}`, 'g'), '<u>$1</u>');
		this.innerHTML = '';
		this.appendChild(span);
	}
}

if (!customElements.get('underline-element') && window.underlineLogic) {
	customElements.define('underline-element', UnderlineElement);
}
class ImageWithLBadge extends HTMLElement {
	connectedCallback() {
		if (this.disabled) {
			return;
		}
		this.image = this.querySelector('img');
		this.badge = this.querySelector('svg');
		this.paths = Array.from(this.badge.querySelectorAll('path'));
		this.thickness = this.hasAttribute('data-thickness') ? parseInt(this.getAttribute('data-thickness')) : 30;
		this._render();
		window.addEventListener('resize', theme.utils.throttle(100, this._render.bind(this)));
	}
	_render() {
		this.pathsReacts = this.paths.map((path) => path.getBoundingClientRect().height);
		this.ratio = Math.min(...this.pathsReacts) / Math.max(...this.pathsReacts);
		this.imageHeight = this.getBoundingClientRect().height;
		this.badge.setAttribute('height', `${this.imageHeight + 2 * this.imageHeight * this.ratio}px`);
		this.pathsReacts = this.paths.map((path) => path.getBoundingClientRect().height);
		const badgeOffsetPosition = Math.floor(Math.min(...this.pathsReacts));
		this.badge.style.bottom = `${-badgeOffsetPosition}px`;
		this.style.margin = `${badgeOffsetPosition}px 0`;
		if (this.thickness < 30) {
			const parent = this.closest('.feature-row__item');
			parent.style.height = 'auto';
			parent.style.height = `${parent.getBoundingClientRect().height - badgeOffsetPosition}px`;
			this.style.marginBlock = `${badgeOffsetPosition / 2 - 2}px ${badgeOffsetPosition / 2}px`;
			parent.style.overflow = 'hidden';
		}
	}
	get disabled() {
		return this.hasAttribute('disabled');
	}
}
customElements.define('image-with-l-badge', ImageWithLBadge);

class CustomLanguageSelector extends HTMLElement {
	constructor() {
		super();
		this.languageSelectors = this.querySelectorAll('button');
		this.form = this.querySelector('form');
		this.formInput = this.querySelector('input[language-input]');
		this.selectorButtons = this.querySelectorAll('button');
	}
	connectedCallback() {
		this._initButtons(this.selectorButtons);
	}

	_sendForm(button) {
		const language = button.getAttribute('lang');
		this._changeInput(language);
		this.form.querySelector('input').value = language;
		this.form.submit();
	}

	_changeInput(value) {
		this.formInput.value = value;
	}

	_initButtons(buttons) {
		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				this._sendForm(button).bind(this);
			});
		});
	}
}

customElements.define('custom-language-selector', CustomLanguageSelector);
